import { render, staticRenderFns } from "./ProposalOfUnsoldLotsModal.vue?vue&type=template&id=147b1f4c"
import script from "./ProposalOfUnsoldLotsModal.vue?vue&type=script&lang=js"
export * from "./ProposalOfUnsoldLotsModal.vue?vue&type=script&lang=js"
import style0 from "./ProposalOfUnsoldLotsModal.vue?vue&type=style&index=0&id=147b1f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports